const CART_STORAGE_KEY = 'cartStorage';
const writeToLocalStorage = (items, dealerId) => {
    window.localStorage.setItem(CART_STORAGE_KEY, JSON.stringify({
        dealerId : dealerId,
        items : items,
    }));
}
export default {
    namespaced : true,
    state : {
        dealerId : null,
        items : [],
        initialized : false,
    },
    getters : {
        totalQuantity : (state) => {
            let quanity = 0;
            state.items.forEach(i => {
                quanity += i.quantity;
            });
            return quanity;
        }
    },
    mutations : {
        addItem (state, item) {
            item.addedAt = new Date().getTime();
            state.items.push(item);
            writeToLocalStorage(state.items, state.dealerId);
        },
        updateItem (state, item) {
            const i = state.items.find(i => i.variantId === item.variantId);
            if(!i){
                return;
            }
            Object.assign(i, item);
            writeToLocalStorage(state.items, state.dealerId);
        },
        removeItem (state, variantId) {
            state.items = state.items.filter(i => i.variantId !== variantId);
            writeToLocalStorage(state.items, state.dealerId);
        },
        removeAll (state) {
            state.items = [];
            writeToLocalStorage(state.items, state.dealerId);
        },
    },
    actions : {
        initialize (context, dealerId) {
            context.state.dealerId = dealerId;
            let cart = window.localStorage.getItem(CART_STORAGE_KEY);
            if(!cart) {
                return;
            }
            cart = JSON.parse(cart);
            if(cart.dealerId !== dealerId) {
                return;
            }
            context.state.items = cart.items;
        },
    }
};
